import SubmissionSuccess from "@/features/survey/submission-success/SubmissionSuccessPage";

const SubmissionSuccessPage = () => {
  return <SubmissionSuccess />;
};

export default SubmissionSuccessPage;
